import React, { useMemo } from 'react';
import CommonVisualInsights from '../CommonVisualInsights';

const cohorts = [
    { label: "Pregnancy", non: "preg_non_anaemic", mild: "preg_mild", mod: "preg_moderate", sev: "preg_severe" },
    { label: "Lactating Women", non: "lactating_non_anaemic", mild: "lactating_mild", mod: "lactating_moderate", sev: "lactating_severe" },
    { label: "IFA Tabs (ANC)", non: "ifa_anc_non_anaemic", mild: "ifa_anc_mild", mod: "ifa_anc_moderate", sev: "ifa_anc_severe" },
    { label: "IFA Tabs (PNC)", non: "ifa_pnc_non_anaemic", mild: "ifa_pnc_mild", mod: "ifa_pnc_moderate", sev: "ifa_pnc_severe" }
];

const JananiVisualInsights = ({ chartData, loading }) => {
    // Overall Totals
    const overallTotals = chartData?.overallTotals || { total_normal: 0, total_mild: 0, total_moderate: 0, total_severe: 0 };

    // Cohort Series for Stacked Column Chart
    const cohortSeriesData = useMemo(() => {
        let nonData = [], mildData = [], modData = [], sevData = [];
        const mapping = [
            { label: "Pregnancy", key: "pregnancy" },
            { label: "Lactating Women", key: "lactating" },
            { label: "IFA Tabs (ANC)", key: "ifa_anc" },
            { label: "IFA Tabs (PNC)", key: "ifa_pnc" }
        ];
        const categories = mapping.map(c => c.label);

        if (chartData?.groupBreakdown) {
            mapping.forEach((m) => {
                const groupData = chartData.groupBreakdown[m.key] || {};
                nonData.push(groupData.non_anaemic ?? groupData.total_normal ?? groupData.total_non_anaemic ?? 0);
                mildData.push(groupData.mild ?? groupData.total_mild ?? 0);
                modData.push(groupData.moderate ?? groupData.total_moderate ?? 0);
                sevData.push(groupData.severe ?? groupData.total_severe ?? 0);
            });
        }
        return { categories, nonData, mildData, modData, sevData };
    }, [chartData]);

    // Timeline Trend Data
    const timelineSeriesData = useMemo(() => {
        let dates = [], nonList = [], mildList = [], modList = [], sevList = [];
        if (chartData?.timelineTrend) {
            chartData.timelineTrend.forEach((t) => {
                dates.push(t.date);

                let non = t.total_normal ?? t.total_non_anaemic ?? 0;
                let mild = t.total_mild ?? 0;
                let mod = t.total_moderate ?? 0;
                let sev = t.total_severe ?? 0;

                if (non === 0 && mild === 0 && mod === 0 && sev === 0) {
                    non = (t.preg_non_anaemic || 0) + (t.lactating_non_anaemic || 0) + (t.ifa_anc_non_anaemic || 0) + (t.ifa_pnc_non_anaemic || 0);
                    mild = (t.preg_mild || 0) + (t.lactating_mild || 0) + (t.ifa_anc_mild || 0) + (t.ifa_pnc_mild || 0);
                    mod = (t.preg_moderate || 0) + (t.lactating_moderate || 0) + (t.ifa_anc_moderate || 0) + (t.ifa_pnc_moderate || 0);
                    sev = (t.preg_severe || 0) + (t.lactating_severe || 0) + (t.ifa_anc_severe || 0) + (t.ifa_pnc_severe || 0);
                }

                nonList.push(non);
                mildList.push(mild);
                modList.push(mod);
                sevList.push(sev);
            });
        }
        return { dates, nonList, mildList, modList, sevList };
    }, [chartData]);

    // District Risk Data
    const districtRiskData = useMemo(() => {
        let categories = [], nonSeries = [], mildSeries = [], moderateSeries = [], severeSeries = [];
        if (chartData?.districtLeaderboard) {
            chartData.districtLeaderboard.forEach((d) => {
                categories.push(d.district_name);

                let non = d.total_normal ?? d.total_non_anaemic ?? 0;
                let mild = d.total_mild ?? 0;
                let mod = d.total_moderate ?? 0;
                let sev = d.total_severe ?? 0;

                if (non === 0 && mild === 0 && mod === 0 && sev === 0) {
                    non = (d.preg_non_anaemic || 0) + (d.lactating_non_anaemic || 0) + (d.ifa_anc_non_anaemic || 0) + (d.ifa_pnc_non_anaemic || 0);
                    mild = (d.preg_mild || 0) + (d.lactating_mild || 0) + (d.ifa_anc_mild || 0) + (d.ifa_pnc_mild || 0);
                    mod = (d.preg_moderate || 0) + (d.lactating_moderate || 0) + (d.ifa_anc_moderate || 0) + (d.ifa_pnc_moderate || 0);
                    sev = (d.preg_severe || 0) + (d.lactating_severe || 0) + (d.ifa_anc_severe || 0) + (d.ifa_pnc_severe || 0);
                }

                nonSeries.push(non);
                mildSeries.push(mild);
                moderateSeries.push(mod);
                severeSeries.push(sev);
            });
        }
        return { categories, nonSeries, mildSeries, moderateSeries, severeSeries };
    }, [chartData]);

    return (
        <CommonVisualInsights
            loading={loading}
            overallTotals={overallTotals}
            cohortSeriesData={cohortSeriesData}
            timelineSeriesData={timelineSeriesData}
            districtRiskData={districtRiskData}
        />
    );
};

export default JananiVisualInsights;
